import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import type { StatsAttributes } from '../../utils/api-types.ts';
import { getStats } from '../../builders/stats.ts';

function statsAttributesFromContent(content: unknown): StatsAttributes {
  if (typeof content !== 'object' || content === null) {
    return {};
  }

  if ('meta' in content) {
    const meta = (content as { meta?: StatsAttributes }).meta;
    return meta ?? {};
  }

  return content;
}

export default class ExploreIndexRoute extends Route {
  @service declare store: Store;

  async model() {
    try {
      const statsResult = await this.store.request(getStats());
      const attrs = statsAttributesFromContent(statsResult.content);
      const itemCountsByType = Object.fromEntries(
        (attrs.itemsByType ?? []).map((t) => [t.type, t.count])
      );
      return {
        itemCountsByType,
        totalRecipes: attrs.totalRecipes ?? 0,
        loadError: false as const,
      };
    } catch {
      return {
        itemCountsByType: {} as Record<string, number>,
        totalRecipes: 0,
        loadError: true as const,
      };
    }
  }
}
